import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function MaterialIssuePage() {
  const [rows, setRows] = useState([]);
  const [productionOrders, setProductionOrders] = useState([]);
  const [materials, setMaterials] = useState([]);

  const [data, setData] = useState({
    production_id: "",
    raw_material_id: "",
    quantity: ""
  });

  useEffect(() => {
    fetchMaterialIssues();
    fetchProductionOrders();
    fetchMaterials();
  }, []);

  // Fetch MaterialIssue list
  const fetchMaterialIssues = () => {
    axios.get(baseUrl + "material-issues/")
      .then(res => setRows(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Material Issues", "error"));
  };

  // Fetch Production Orders
  const fetchProductionOrders = () => {
    axios.get(baseUrl + "production-orders/")
      .then(res => setProductionOrders(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Production Orders", "error"));
  };

  // Fetch Raw Materials (Equipment)
  const fetchMaterials = () => {
    axios.get(baseUrl + "eqp-search/")
      .then(res => setMaterials(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Materials", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // Submit new Material Issue
  const formSubmit = () => {
    if (!data.production_id || !data.raw_material_id || !data.quantity) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("production", data.production_id);
    _formData.append("raw_material", data.raw_material_id);
    _formData.append("quantity", data.quantity);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "material-issues/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          title: "Material Issue Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });
        setData({ production_id: "", raw_material_id: "", quantity: "" });
        fetchMaterialIssues();
      }
    })
    .catch(() => Swal.fire("Error", "Something went wrong", "error"));
  };

  // Delete Material Issue
  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "material-issues/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "Material Issue deleted", "success");
            fetchMaterialIssues();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "production",
      headerName: "Production Order",
      width: 150,
      renderCell: (params) => params.row.production?.order_no || "Unknown"
    },
    {
      field: "raw_material",
      headerName: "Raw Material",
      width: 150,
      renderCell: (params) => params.row.raw_material?.product || "Unknown"
    },
    { field: "quantity", headerName: "Quantity", width: 150 },
    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/material-issue/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning btn-sm"
        >
          Edit
        </Link>
      ),
      width: 120
    },
    {
      field: "delete",
      headerName: "Delete",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm"
        >
          Delete
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add Material Issue</h4>

        <select
          name="production_id"
          value={data.production_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Production Order</option>
          {productionOrders.map(po => (
            <option key={po.id} value={po.id}>
              {po.order_no} - {po.product?.name}
            </option>
          ))}
        </select>

        <select
          name="raw_material_id"
          value={data.raw_material_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Raw Material</option>
          {materials.map(m => (
            <option key={m.id} value={m.id}>
              {m.product}
            </option>
          ))}
        </select>

        <input
          type="number"
          className="form-control mt-3"
          placeholder="Quantity"
          name="quantity"
          value={data.quantity}
          onChange={inputHandler}
        />

        <button className="btn btn-success mt-3" onClick={formSubmit}>
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": { color: "primary.main" }
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>
    </div>
  );
}

export default MaterialIssuePage;
